import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { CarrierCleanupQuery, CarrierCleanupQueryResult, CarrierReplacement } from './cleanup-administration.model';

@Injectable({
  providedIn: 'root'
})
export class CleanupAdministrationService {

  constructor(private httpService: HttpService) { }

  public findCarrierByQuery(query: CarrierCleanupQuery): Observable<CarrierCleanupQueryResult[]> {
    return this.httpService.postWithContext<CarrierCleanupQueryResult[]>(environment.cleanupAdminEndpoint + '/find-carriers', query);
  }

  public replaceCarriers(replacement: CarrierReplacement): Observable<CarrierCleanupQueryResult[]> {
    return this.httpService.postWithContext<CarrierCleanupQueryResult[]>(environment.cleanupAdminEndpoint + '/replace-carriers', replacement);
  }
}
